import React, {useState, useEffect, useRef} from "react";
import {Table} from "./table";

import "./misc.css";

import axios from "axios";


function capitalize(s) {

    return s && s[0].toUpperCase() + s.slice(1);
}

export const Space = (props) => {
      /// OE??!!! Just a space
      var count = props.count ? props.count : 1;
      var sp = [];
      for (var i = 0; i < count; i++) {
        sp.push(<span key={i}>&nbsp;</span>)

      }
          return(
            <>
              {sp}
              </>
          )
      }
          

  
export const Pager = (props) => {

// praps are nRows, pageSize, offset, link

  var pageSize = props.pageSize ? Number(props.pageSize) : 30;

        var nPages = props.nRows/pageSize
        var o = Number(props.offset ? props.offset : 0)
        var p = o-pageSize
        if (p < 0)
            p = 0
        var n = o+pageSize;

        if (n > props.nRows-1)
            n = props.nRows-1
        if (nPages > 10)
          nPages = 10; 

        var middle = []
        var s1 = {float: "left", margin: "3px"};

        for (var i = 0; i < nPages; i++) {
            if (i*props.pageSize != o)
                middle.push(<div key={i+1} style={s1}><a href={props.link+"&o="+i*pageSize}>{i+1}</a></div>)
            else
                middle.push(<div key={i+1} style={s1}><a style={{color: "red"}} href={props.link+"&o="+i*pageSize}>{i+1}</a></div>)

        }
    
        if (nPages < 2) {
          return <div></div>
        }
        else {


        return(
        <><span style={{width:"100%", display: "flex", justifyContent: "center"}}>
        <div key="0" style={{float: "left"}}><a href={props.link+"&o="+p}>&#8592;</a></div>
          {middle}  
          <div key="100" style={{float: "left"}}><a href={props.link+"&o="+n}>&rarr;</a></div>
         </span>
      </>
        )
      }    
    }
    
export const UrlSelector = (props) => {
//console.log("w", props.w)

    var links = [];
    for (var i = 0; i < props.links.length; i+= 2) {
      // ??? Note the 2* is a little confusing.  Try to change it.
      
      var c = (i == 2*props.w) ? "#0000ff" : "#ff0000";
      
        links.push(<a key={2*i} style={{color:c}} href={props.links[i+1]}>{props.links[i]}</a>);
        links.push(<Space key={2*i+1}/>);
    }

    return (

        <>{links}</>
    )

}
    

export const ButtonList = (props) => {

    var list = [];
    var i = 0;
    props.list.map((item) => {
        list.push(<div key={i++}>{item.name} <button type="button" onClick={() => props.onClick(item.id)}>{props.title}</button></div>)
    })
    return <div>{list}</div>
}



export const Modal = (props) => {

 // className="modal-main"

  useEffect(() => {

    // OE??!! Must be a better way to do this


    const d1 = document.getElementById("Modalxx12")
    d1.addEventListener("click", (event) => {

      var es = document.getElementsByClassName("modal display-block");

      if (es[0] && event.target.id == "Modalxx12") {
        props.handleClose();
      }


    })}, [])


//    var width = props.style?.width ? props.style?.width : "90%";

    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    width = width*.9;

    var maxWidth = props.maxWidth ? props.maxWidth : 850;

    if (width > maxWidth) {
      width = maxWidth;
    }

    const style1 = {
      
      width: width, 
      position:"fixed",
      background: "white",
      height: "auto",
      top: "50%",
      left: "50%",
      borderStyle: "solid",
      padding: "10px",
      transform: "translate(-50%,-50%)",

    }

   return (
          <div id="Modalxx12" className={props.show ? "modal display-block" : "modal display-none"}>
            <section style={style1} id={props.id}>  
            <div>
      
              {props.children}
              <button onClick={() => {
                props.handleClose();
              
              }}>Close</button>
              </div>
              <br/>
      
            </section>  
          </div>
        );
 }
    

    
//export const Modal = Modal1;
    

export const Drawer = (props) => {

return <div className="w3-dropdown-hover">
<button className="w3-button" style={{color: "#217120"}}>&#9776;</button>
<div className="w3-dropdown-content w3-bar-block w3-border">
<div>
        {props.children}
  </div>
</div>
</div>

}

/*
export const Drawer = (props) => {
    return <div style={{position: "relative", display: "inline-block"}}>
    <span style={{fontSize:"30px",cursor:"pointer"}} onClick={() => {
      
      var x = document.getElementById("Demo1");
  if (x.className.indexOf("w3-show") == -1) {
  x.className += " w3-show";
  } else { 
  x.className = x.className.replace(" w3-show", "");
  }
    
    }}>&#9776;</span>
    <div id="Demo1" style={{display: "none", position: "absolute"}}  className="w3-dropdown-content w3-bar-block w3-border w3-hide">
    <div>
        {props.children}
  </div></div></div>
  }
  
  */
  export const getLocalDate = function(d1)
  {
    return new Date(d1).toLocaleDateString();
  }
  
  export const Section = (props) => {
  
    return <div>
      {props.children}
    </div>
  }

  export const Page = (props) => {
  
    return <div><center>
      {props.children}
      </center>
    </div>
  }
  
  
  export const SectionList = (props) => {
  
    const [count, setCount] = useState(0);
  
  
    let list;
    
    if (props.list)
    {
      let style;
      list = [];
      var i = 0;
      props.list.map(item => {
        if (props.sel != item)
          style = {};
        else
          style = {color: "red"};
        list.push(<div key={i}><a href="#" onClick={() => {
          if (props.onSelect)
          {
            props.onSelect(item);
          }
  //        alert(item) 
        }
        }><span style={style}>{item}</span></a><br/></div>);
  //      list.push(<br/>);
        i++;
      })
      
    }
    else
    {
      list = <div>1.<br/>2.<br/>3.<br/></div>;
  
    }
    return <div style={{textAlign: "left"}}>
      {list}
    </div>
  
  
  }
  
  /*
  export class SectionList1 extends React.Component
  {
  
  render()
  {
    let list;
    if (this.props.list)
    {
      list = [];
      this.props.list.map(item => {
        list.push(<a href="#" onClick={() => {
          if (this.props.onSelect)
          {
            this.props.onSelect(item);
          }
  //        alert(item) 
        }
        }>{item}</a>);
        list.push(<br/>);
      })
      
    }
    else
    {
      list = <div>1.<br/>2.<br/>3.<br/></div>;
  
    }
    return <div style={{textAlign: "left"}}>
      {list}
    </div>
  
  
  }
  }
  
  export const SectionList = SectionList1;
  */
  
  export const Select = (props) => {
  
//    var hic = props.onChange;

var hic = props.onChange ? props.onChange : (event) => { if (props.saveNeeded) {props.saveNeeded(true);} props.setter(event.target.value) }; 


    const [list, setList] = useState([]);
  // ???!!! consider making options a map to avoid dup keys
    useEffect(() => {

      var list1 = [];
  //    list.push(<option>Please Select</option>)
  
      if (props.please) {

        list1.push(<option key ={0} value={props.please.id}>{props.please.name}</option>);
      }
      if (props.options) {
      props.options.map(item => {
        list1.push(<option key ={item.id} value={item.id}>{item.name}</option>);
      })
    }
      setList(list1);
    }, [props.options]);

    var prompt = props.prompt ? props.prompt : props.title;
    
    if (prompt) {
      prompt = <><label htmlFor={props.name}>{prompt}</label>: </>

    }

      return (<>
      {prompt}
      <select id={props.id} name={props.name} value={props.value} onChange={(event) => {

        if (props.saveNeeded) {
          props.saveNeeded(true); 
        }

        hic(event);

        if (props.onChange1) {
          props.onChange1(event.target.value);
        }
        

      }}>
        {list}
      </select>
      </>);
  
  }
  
  
  
  
  
  const currentDate = new Date();
  
  const categories = [
    { name: "Last 5 Years", dateBegin: findDate(1, 5*12), dateEnd: findDate() },
    { name: "All", dateBegin: null, dateEnd: null},
    { name: "Custom", dateBegin: null, dateEnd: null },
    { name: "Today", dateBegin: findDate(), dateEnd: findDate() },
    { name: "Yesterday", dateBegin: findDate(1), dateEnd: findDate(1) },
    { name: "This Week", dateBegin: findDate(currentDate.getDay()), dateEnd: findDate() },
    { name: "Last Week", dateBegin: findDate(7 + currentDate.getDay()), dateEnd: findDate(7 - currentDate.getDay()) },
    { name: "Past 7 Days", dateBegin: findDate(7), dateEnd: findDate() },
    { name: "This Month", dateBegin: findDate(currentDate.getDate() - 1), dateEnd: findDate() },
    { name: "Last Month", dateBegin: findDate(1, 1), dateEnd: findDate(currentDate.getDate()) },
    { name: "Past 30 Days", dateBegin: findDate(30), dateEnd: findDate() },
    { name: "Past 6 Months", dateBegin: findDate(1, 6), dateEnd: findDate() },
    { name: "This Year", dateBegin: findDate(1, currentDate.getMonth()), dateEnd: findDate() },
    { name: "Past 12 Months", dateBegin: findDate(1, 12), dateEnd: findDate() },
  ];
  
  function findDate(dayBuffer, monthBuffer) {
      let curr = new Date();
  
      if (dayBuffer) {
        if (monthBuffer) {
          curr.setDate(dayBuffer);
          curr.setMonth(curr.getMonth() - monthBuffer);
        } else {
          curr.setDate(curr.getDate() - dayBuffer);
        }
      }
  
      return curr.toISOString().substr(0,10);
  }
  
  
  class datePicker extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        category: this.props.cat? this.props.cat : 2,
        dateBegin: this.props.startDate? this.props.startDate : categories[2].dateBegin,
        dateEnd: this.props.endDate? this.props.endDate: categories[2].dateEnd,
      };
      this.props.parent?.setState({date1:this.state.dateBegin, date2: this.state.dateEnd})
      if (this.props.setDateFilter)
      {
        this.setDateFilter = this.props.setDateFilter.bind(this);
        this.setDateFilter(this.state.dateBegin, this.state.dateEnd, this.state.category);
      }
    }
  
    componentDidMount() {
      if (this.setDateFilter)
      {
        this.setDateFilter(this.state.dateBegin, this.state.dateEnd, this.state.category);
  
      }
    }
  
    handleSelect(event) {
      const value = event.target.value;
  
      console.log(value)
      // Future proofing for potental cases
      if (!categories[value].dateBegin) {
        document.getElementById("dateBegin").value = "";
      }
      if (!categories[value].dateEnd) {
        document.getElementById("dateEnd").value = "";
      }
  
      // Callback to set the dates in the parent once the initial setState function is finished
      this.props.parent.setState({date1: categories[value].dateBegin, date2: categories[value].dateEnd });
      this.setState({ category: value, dateBegin: categories[value].dateBegin, dateEnd: categories[value].dateEnd }, () => {
        if (this.setDateFilter)
          this.setDateFilter(this.state.dateBegin, this.state.dateEnd, this.state.category);
      });
    }
  
    // Man, callbacks really suck, don't they?
    // (Closure just so only silly callback will work correctly)
    checkDate(name, oldDate) {
      return () => {
        if (Date.parse(this.state.dateBegin) > Date.parse(this.state.dateEnd)) {
          this.setState({[name]: oldDate});
          alert("Invalid Date Range");
        } else {
          this.setState({category: 2})
          this.props.parent.setState({date1: this.state.dateBegin, date2: this.state.dateEnd });
  
          if (this.setDateFilter)
            this.setDateFilter(this.state.dateBegin, this.state.dateEnd);
        }
      }
    }
  
    handleChange(event) {
      const oldDate = this.state[event.target.name];
  
      this.setState({[event.target.name]: event.target.value}, this.checkDate(event.target.name, oldDate));
      
    }
  
    handleSubmit(event) {
      event.preventDefault();
      
      this.setDateFilter(this.state.dateBegin, this.state.dateEnd, this.state.category);
    }
  
    render() {
      return (
        <div>
          Date Range:
          <form onSubmit={this.handleSubmit.bind(this)}>
            <label>
              Category:{" "}
              <select
                value={this.state.category}
                onChange={this.handleSelect.bind(this)}
              >
                {categories.map((item, index) => (
                  <option key={index} value={index}>
                    {item.name}
                  </option>
                ))}
              </select>
            </label>
            <label>
              {" "}Start Date:{" "}
              <input
                id="dateBegin"
                type="date"
                name="dateBegin"
                onChange={this.handleChange.bind(this)}
                value={this.state.dateBegin}
              />
            </label>
            <label>
              {" "}End Date:{" "}
              <input
                id="dateEnd"
                type="date"
                name="dateEnd"
                onChange={this.handleChange.bind(this)}
                value={this.state.dateEnd}
              />
            </label>
            {/*
              {" "}
              <input type="submit" value="Set" />
            */}
          </form>
        </div>
      );
    }
  }
  
  export const DatePicker = datePicker
  
  export const AnimModal = (props) => {
  
  return (
  <div id="myModal" className={props.show ? "modal display-block" : "modal display-none"}>
  
  
  <div className="modal-content">
    <div className="modal-header">
      <span className="close" onClick={() => {
        props.close();
      }}>&times;</span>
      <h2>Modal Header</h2>
    </div>
    <div className="modal-body">
      <p>Some text in the Modal Body</p>
      <p>Some other text...</p>
    </div>
    <div className="modal-footer">
      <h3>Modal Footer</h3>
    </div>
  </div>
  
  </div>)
  
  }
  
  
  
  export const UploadFile = (props) => {

    const [progress, setProgress] = useState(0);

function onFile() {
    var file = document.getElementById("file_upload").files[0];
  
    var formData = new FormData();
    console.log(file);
    
    formData.append('file', file);
    formData.append('id', props.id) 
    formData.append("dw", "saveFile")
    axios({
      headers: {
        "Content-Type": "multipart/form-data",
      },
      method: "POST",
      data: formData,
      url: props.link, // route name
//      baseURL: g_link, //local url
      onUploadProgress: progress => {
        const { total, loaded } = progress;
        const totalSizeInMB = total / 1000000;
        const loadedSizeInMB = loaded / 1000000;
        const uploadPercentage = (loadedSizeInMB / totalSizeInMB) * 100;
//        setUploadPercentage(uploadPercentage.toFixed(2));
        this.setState({progress: uploadPercentage+"%"});
//        console.log("total size in MB ==> ", totalSizeInMB);
//        console.log("uploaded size in MB ==> ", loadedSizeInMB);
      },
      encType: "multipart/form-data",
    }).then((res) => {
/*      if (!this.state.id && res.code == 200)
        {
          this.setState({id: res.result.id, progress: "0%"});
        }
        this.setState({progress: "0%"}); */
        alert("File was uploaded");
    }).catch(error => { 
      alert(error);
    });    

  }

    return <>
<input type="file" className="form-control-file" id="file_upload"  onChange={onFile} /><br/>
<div className="w3-grey" style={{height: "24px", width: progress}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>

<img src={props.img} width="50px" alt="profile image"/>



    </>
  }

  export const HoriList = (props) => {
  
    const [count, setCount] = useState(0);
  
  
    let list;
    
    if (props.list)
    {
      let style;
      list = [];
      var i = 0;
      props.list.map(item => {
        if (props.sel != item)
          style = {};
        else
          style = {color: "red"};
          style.margin = "5px";

        list.push(<div key={i} style={{float: "left"}}><a href="#" onClick={() => {
          if (props.onSelect)
          {
            props.onSelect(item);
          }
  //        alert(item) 
        }
        }><span style={style}>{item}</span></a></div>);
  //      list.push(<br/>);
        i++;
      })
      
    }
    else
    {
      list = <div>1.<br/>2.<br/>3.<br/></div>;
  
    }
    return <div style={{textAlign: "left", float: "left"}}>
      {list}
    </div>
  
  
  }



  export const TagList = (props) => {

    const [count, setCount] = useState(0);
    const [tag, setTag] = useState("0");
   
    var list = [];

    var map1 = {}

    if (!props.list) {
      console.log("Please provide list property for element tagList", props.tagList);
      return;
    }

    if (!props.selected) {
      console.log("Please provide selected property for element tagList", props.selected);
      return;
    }


list.push(<option  key="0" value="0">Please Select</option>);

    props.list.map(item => {
      map1[item.id] = item.name;
      list.push(<option  key={item.id} value={item.id}>{item.name}</option>);
    })

    var s1 = [];

    var i = 0;
    props.selected.map((tagId) => {

      s1.push(<div key={i} style={{float: "left"}} >{map1[tagId]} <button style={{padding: "1px", fontSize: "10px"}} onClick={() => {

        var n = props.selected.indexOf(tagId)

        props.selected.splice(n, 1);

        setCount(count+1);


      }}>X</button><Space/></div>)
      i++;
    })

        return (<div>
    {s1}
    
          <select name="tag" value={tag} onChange={(event) => {

            setTag(event.target.value);

          }}>
            {list}
          </select><Space/> <button onClick={() => {
            
            if (props.selected.length >= 3)
              return;

              if (tag == "0")
                return;
                
            if (props.selected.indexOf(tag) != -1)
              return;

            if (props.saveNeeded) {
              props.saveNeeded(true); 
            }

            props.selected.push(tag)

            setCount(count+1);


          }}>Add</button>
        
        
        
        </div>)
    
      }
    
  export const DateTime = (props) => {

    var prompt = props.prompt ? props.prompt : capitalize(props.name);
    var hic = props.onChange ? props.onChange : (event) => { if (props.saveNeeded) {
      props.saveNeeded(true);} 
      props.setter(event.target.value) }; 

return <>

<label htmlFor={props.name}>{prompt}</label>:<Space/>
  <input type="datetime-local" onChange={hic} name={props.name} value={props.value}/>

</>

  }


   export const CheckBox = (props) => {

        var checked = props.check ? props.checked : props.value;

        var hic = props.onChange ? props.onChange : (event) => { if (props.saveNeeded) {
          props.saveNeeded(true);
        } 
          var c = checked ? false : true;
          props.setter(c) 
      }; 

          var prompt = props.prompt ? props.prompt : capitalize(props.name);
        return <>
          <input type="checkbox" name={props.name} checked={checked} onChange = {hic}  /><Space/>
          <label htmlFor={props.name}>{prompt}</label>
        </>


   }

   export const Checkbox = CheckBox;

   //https://legacy.reactjs.org/docs/typechecking-with-proptypes.html#default-prop-values

   export const CheckBoxTable = (props) => {

    return (
      <tr>
      <td><label htmlFor={props.name}>{props.prompt}</label></td>
      <td><input name={props.name} type="checkbox" checked={props.checked} onChange = {props.hic} /></td>
      
      </tr>

    )
}

export const Password = (props) => {

  return (
    <>
    <label htmlFor={props.name}>{props.prompt}</label>
    <input type="password" placeholder={props.placeholder} id={props.id} name={props.name} className={props.className} />
    <Space/>
    <input type="checkbox" onClick={() => {
      var x = document.getElementById(props.id);
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }


    }}/> Show Password
    </>

  )
}

export const Search = (props) => {

  const [term, setTerm] = useState(props.term);

  return <input name="term" value={term} 

  onKeyDown={async (event) => {
  
  
    if (event.code == "Enter") {
      
      document.location = window.location.origin + "?q="+encodeURI(term);
  
    }
    
  }}
  
  
  onChange={(event) => {
  
  //      console.log(event.target.value)
      setTerm(event.target.value)
  
  }} type="text"/>


}

export const AreaPrompt = (props) => {
 
  var hic = props.onChange ? props.onChange : (event) => { if (props.saveNeeded) {
                                                                props.saveNeeded(true);} props.setter(event.target.value) }; 

  var title = props.title ? <label htmlFor={props.name} className="col-sm-2 col-form-label">{props.title}:</label> : capitalize(props.name);
  
  var className = props.className ? props.className : "form-control";

  return(
<div className="form-group row">
  {title}
<div className="col-sm-7"><textarea className={className} onChange={hic} id={props.eid} style={props.style} rows={props.rows} cols={props.cols} value={props.value} name={props.name} /></div>
</div>
  )
}


export const TextPrompt = (props) => {
 
  var hic = props.onChange ? props.onChange : (event) => { if (props.saveNeeded) { props.saveNeeded(true);}  props.setter(event.target.value) };   

  var title = props.title ? <label htmlFor={props.name} className="col-sm-2 col-form-label">{props.title}:</label> : capitalize(props.name);
  
  const tween = props.tween === undefined ? null : props.tween;

  var className = props.className ? props.className : "lefty";


      return(
        <div className="form-group">
    {title}{tween}
    <input className={className} type='text' onKeyUp={(e) => {

      if (e.key === "Enter") {
        
        if (props.onEnter) {
          props.onEnter();
        }

      }
        

    }} onChange={hic} id={props.eid} value={props.value} name={props.name} /></div>
    
      )
  }
  
export const EmailPrompt = (props) => {

//  const [value, setValue] = useState(props.value);

  var hic = props.onChange ? props.onChange : (event) => { if (props.saveNeeded) {props.saveNeeded(true);} props.setter(event.target.value) }; 
      return(
  <div className="form-group row">
    <label for="name" className="col-sm-2 col-form-label">{props.title}:</label><div className="col-sm-7"><input className="form-control" type='email' onChange={hic} value={props.value} name='name' /></div>
  </div>
      )
  }
  
  
export const Error = (props) => {

  return(<div style={{color: "red"}}>{props.msg}</div>)

}

export const Tab = (props) => {

    const onClick1 = () => {
      const label = props.label;
      const onClick = props.onClick;

      onClick(label);
    }
  
      const activeTab = props.activeTab;
      const label = props.label;

      let className = 'tab-list-item';
  
      if (activeTab === label) {
        className += ' tab-list-active';
      } 
  
      return (
        <li
          className={className} 
          onClick={onClick1}
        >
          {label}
        </li>
      );
    }
  

export class Tabs extends React.Component {
  /*  
    static propTypes = {
      children: PropTypes.instanceOf(Array).isRequired,
    }
  */
  
    constructor(props) {
      super(props);
  
      this.state = {
        activeTab: this.props.children[0].props.label,
        tag: []
      };
    }
  
    onClickTabItem = (tab) => {
      this.setState({ activeTab: tab });
      this.props.changePreview(tab);
    }
    render() {
      const {
        onClickTabItem,
        props: {
          children,
        },
        state: {
          activeTab,
        }
      } = this;
  
      var key1 = 0;
      return (
        <div className="tabs" key={key1++}>
          <ol className="tab-list">
            {children.map((child) => {
              const { label } = child.props;
  
              return (
                <Tab
                  activeTab={activeTab}
                  key={label}
                  label={label}
                  onClick={onClickTabItem}
                />
              );
            })}
          </ol>
          <div className="tab-content">
            {children.map((child) => {
              if (child.props.label !== activeTab) 
                return <div key={key1++} style={{display:"none"}}>{child.props.children}</div>;
              return <div key={key1++} style={{display:"block"}}>{child.props.children}</div>;
            })}
          </div>
        </div>
      );
    }
  }  

export const ExitPrompt = ({ saveNeeded }) => {
  useEffect(() => {
    const onBeforeUnload = (e) => {
      if (saveNeeded) {
        e.preventDefault();
        e.returnValue = "";
     }
    };
    window.addEventListener("beforeunload", onBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
    };
  }, [saveNeeded]);
};

export const Button = (props) => {

  return (
  <button id={props.id} style={{margin: "3px"}} onClick={(event) => {
  
    props.onClick(event);
  
  }}>{props.title}</button>
  )
  
  
  }
  

export const StateButton = (props) => {


    return (
    <button id={props.id} onClick={(event) => {
    
      props.onClick(event);
    
    }}>{props.titles[props.state]}</button>
    )
    
    
    }
  

export const SaveButton = (props) => {

// https://stackoverflow.com/questions/53024496/state-not-updating-when-using-react-state-hook-within-setinterval  

  const initalState = 10;
  

  const saver = props.saver ? props.saver : props.onClick;
  const [count, setCount] = useState(initalState);
  const counterRef = useRef(initalState);
  const [started, setStarted] = useState(false);
  const startedRef = useRef(started);

  const [finished, setFinished] = useState(false);

    useEffect(() => {
      counterRef.current = count;
      startedRef.current = started;
    })

    useEffect(() => {
if (props.autoSave) {
      if (props.saveNeeded) {
        setStarted(true);
      } 
      else {
        setCount(10);
        setStarted(false);
      }

    }
    }, [props.saveNeeded])

    useEffect(() => {

      if (finished == true) {
        saver();
        setCount(null);
        setFinished(false);
        setStarted(false);


      }
  }, [finished])

    useEffect(() => {
      setCount(10);
      setInterval(() => {
        if (!startedRef.current) {
          return;
        }
        if (counterRef.current == 0) {
          setFinished(true);
        } 
        else {

          setCount(counterRef.current - 1);

        }

      }, 1000);
    }, []);
      

    const c1 = props.autoSave === true ? count: "";

return (

  <div style={{display: props.saveNeeded ? "inline" : "none"}}>
    <ExitPrompt saveNeeded={props.saveNeeded} />
<button onClick={() => {

  saver();

}}>Save</button>&nbsp;{c1}
</div>
)


}


export class Saver {

  start = 0;
  timeout = null;
  save = null;
  waitTime = 700;

  update(name, value) {

    this[name] = value;
//    console.log(name, value, this[name]);
    this.start = Date.now();
//    console.log("update", this.start);
    

    var t1 = this;
    function timeout1() {

//      console.log("timeout", start, Date.now())
      if (Date.now() - t1.start >= t1.waitTime) {
        t1.timeout = null;
        t1.save();
      }
      else {
        t1.timeout = setTimeout(timeout1, t1.waitTime);
      }
    }

    if (!this.timeout) {
      this.timeout = setTimeout(timeout1, t1.waitTime)
    }



  }


}


export const CardCell = (props) =>  {
  
  var slug = props.name.toLowerCase();
  slug = slug.replace(/\s/g, "-");
  slug = slug.replace(/\.|\?|\,/g, "");
  const loc = "/media?id=" + props.id + "&s=" + slug;

  var ownerInfo = props.ownerLink ? 
    <><a href={props.ownerLink}><img width="20px" alt="profile pic" src={props.profilePic}/></a><Space/><a href={props.ownerLink}>{props.row.ownerName}</a></> 
      : <>{props.userName}<Space/></>;

  return (
<>
<div className="w3-container card-links" style={{backgroundColor: "#fbf8f8"}}>
<div className="w3-card-4" style={{width:"260px", height: "400px"}}>
<a href={loc}><img alt={`Picture for ${props.name}`} src={props.pic} style={{width: "260px", height: "180px"}}/></a>
<div style={{fontSize: "17px"}}>
  <a href={loc}>{props.name.substring(0, 90)}</a>
  </div>
  <div style={{textAlign: "left", margin: "10px", fontSize: "13px"}}>
  {props.content}
  <div style={{fontSize: "11px"}}>
    <br/>
  {getLocalDate(props.d1)} {props.nViews}:{props.nLikes}:{props.nComments}<Space/>
  
  {ownerInfo}
  </div>
  </div>
</div>
</div>
</>
)

}

export const InfiniteScroller = (props) => {

// https://stackoverflow.com/questions/9439725/how-to-detect-if-browser-window-is-scrolled-to-bottom

return (

  <>Hello!</>
)


}

export const Grid = (props) => {


  const [selectedRow, setSelectedRow] = useState(-1);


  useEffect(() => {



  }, [])

  var tableRows = [];

  var r = 0;
  props.rows.map((row, i) => {

    var col = 0;

    var tr = row.map(c => {return(<td style={{border:"1px solid", padding:"2px"}} key={col++} onClick={(e) => {

      setSelectedRow(i);

      if (props.onSelect) {

        props.onSelect(i);
      }

    }}>{c}</td>)})

    var style = i === selectedRow ? {backgroundColor:"coral"} : null;

    tableRows.push(<tr style={style}  key={r++}>{tr}</tr>)

  })

  if (props.ref) {

    props.ref.current = {setSelectedRow: setSelectedRow, selectedRow: selectedRow};
  }
  
  
  let addButton;

  if (props.onAdd) {

    addButton = <Button title="Add" onClick={props.onAdd} />
  }

  
  const style = {overflowX: "scroll", padding: "10px"};
  if (props.maxHeight) {

    style.height = props.maxHeight;
    style.overflowY = "auto";

  }

  return (
    <div style={style}>
      {addButton}
    <table style={{border: "1px solid", borderCollapse: "collapse"}}>
    <tbody>
      {tableRows}
      </tbody>
      </table>
    </div>
  )


}

export const PreviewBox = (props) => {

  return (
    <div style={{width: "100%", height: "100%", overflow: "auto"}}>
      {props.children}
    </div>
  )

}

export const BackArrow = (props) => {

  var url = props.url ? props.url : document.referrer;

  return (
    <span style={{textDecoration: "none"}}><a href={url}><span style={{fontSize:'30px'}}>&#8592;</span></a></span>
  )

}